export type BoardGridStyle = "grid" | "dots" | "lines" | "none";

const STORAGE_KEY = "bezpart-board-grid-style";
const DEFAULT_STYLE: BoardGridStyle = "grid";

export const BOARD_GRID_STYLES: BoardGridStyle[] = ["grid", "dots", "lines", "none"];

export const BOARD_GRID_STYLE_LABELS: Record<BoardGridStyle, string> = {
  grid: "Клетка",
  dots: "Точки",
  lines: "Линейка",
  none: "Пустой лист",
};

export const BOARD_GRID_STYLE_HINTS: Record<BoardGridStyle, string> = {
  grid: "Как тетрадь в клетку — удобно для схем и чертежей.",
  dots: "Как в Miro: мягкая сетка из точек.",
  lines: "Горизонтальные линии — для текста и конспектов.",
  none: "Чистый фон без разлиновки.",
};

const listeners = new Set<() => void>();

function parseStyle(raw: string | null): BoardGridStyle {
  if (raw === "grid" || raw === "dots" || raw === "lines" || raw === "none") return raw;
  return DEFAULT_STYLE;
}

export function getBoardGridStyle(): BoardGridStyle {
  try {
    return parseStyle(localStorage.getItem(STORAGE_KEY));
  } catch {
    return DEFAULT_STYLE;
  }
}

export function setBoardGridStyle(style: BoardGridStyle): void {
  try {
    localStorage.setItem(STORAGE_KEY, style);
  } catch {
    /* ignore */
  }
  for (const cb of listeners) cb();
  window.dispatchEvent(new CustomEvent("wb:grid-style-change", { detail: { style } }));
}

export function subscribeBoardGridStyle(onChange: () => void): () => void {
  listeners.add(onChange);
  return () => listeners.delete(onChange);
}
